import { React, PropTypes } from 'imports';
import Checkbox, { Appearance } from 'typed/components/common/Checkbox/Checkbox';
import { toArray } from 'utils';
import Enum from 'utils/Enum';
import './CheckboxGroup.less';

export const Layout = Enum('VERTICAL', 'HORIZONTAL');

export { Appearance };

export const valuePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export class Option extends React.PureComponent {
    static get displayName() {
        return "CheckboxGroup.Option";
    }

    static get propTypes() {
        return {
            value: valuePropType.isRequired,
            className: PropTypes.string,
            disabled: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            className: ''
        };
    }

    render() {
        return null;
    }
}

export default class CheckboxGroup extends React.PureComponent {
    static get Layout() {
        return Layout;
    }

    static get Appearance() {
        return Appearance;
    }

    static get valuePropType() {
        return valuePropType;
    }

    static get Option() {
        return Option;
    }

    static get propTypes() {
        return {
            value: PropTypes.arrayOf(valuePropType),
            layout: PropTypes.oneOf([Layout.HORIZONTAL, Layout.VERTICAL]),
            appearance: PropTypes.oneOf(Object.values(Appearance)),
            className: PropTypes.string,
            disabled: PropTypes.bool,
            onChange: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            value: [],
            layout: Layout.VERTICAL,
            appearance: Appearance.CHECKBOX,
            className: '',
            disabled: false
        };
    }

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (DEBUG && toArray(nextProps.children || []).flatten().some(child => child && child.type !== Option)) {
            throw new Error('Children of RadioGroup must be instances of Checkbox.Option');
        }
    }

    _onChange = (value, sender, checked) => {
        if (this.props.onChange) {
            this.props.onChange(this, this.props.value.copy().toggle(value, checked));
        }
    }

    _layoutClass() {
        const layout = this.props.layout;
        // switch (layout) {
        //     case Layout.VERTICAL: return 'vertical';
        //     ...
        // }
        if (DEBUG) {
            // TODO fix when redux-logger supports Symbols as action types
            if (typeof layout !== 'string') {
                throw new Error(`Incorrect enum value type: ${layout}`);
            }
        }
        return layout.toLowerCase();
    }

    _keyify(child, index) {
        return Array.isArray(child) ? child.map((subchild, subindex) => this._keyify(subchild, index + '.' + subindex)) :
            {
                key: child && child.key ? 'external-' + child.key : 'index-' + index.toString(),
                child
            };
    }

    render() {
        return (
            <div className={`checkbox-group ${this._layoutClass()} ${this.props.disabled ? 'disabled' : ''} ${this.props.className}`}>
                {toArray(this.props.children || [])
                    .map((child, index) => this._keyify(child, index))
                    .flatten()
                    .filter(({ child }) => child)
                    .map(({ child, key }) => (
                        <Checkbox
                            key={key}
                            appearance={this.props.appearance}
                            disabled={this.props.disabled || child.props.disabled}
                            className={child.props.className}
                            value={this.props.value.includes(child.props.value)}
                            onChange={this._onChange.bind(this, child.props.value)}>
                            {child.props.children}
                        </Checkbox>
                    ))}
            </div>
        );
    }
}
